import DsfPptPosterMetaData from "./DsfPptPosterMetaData";

dsf.metadata.add("dsf-ppt-poster-meta-data", DsfPptPosterMetaData);